/* klaasje-motion
   ─────────────────────────────────────────────────────────────
   Laat koppen, tekst, beeld en knoppen zacht binnenkomen zodra ze in
   beeld scrollen (de animatie staat in klaasje-motion.css). Werkt op de
   inhoud (main) en de footer, en slaat alles over wat al een eigen
   beweging heeft.

   Wat bij het laden al in beeld staat blijft met rust, anders flitst het
   even weg. Behalve als het laadscherm er ligt: dan ziet niemand het, en
   komt ook dat binnen zodra het laadscherm vervaagt.

   Een element dat binnen een ander gekozen element valt wordt niet
   apart gedaan: het blok komt als geheel binnen.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DOEL = [
    'h1',
    'h2',
    'h3',
    'p',
    'img',
    'picture',
    'video',
    'form',
    'details',
    '.klaasje-btn',
    '[class*="__media"]',
    '[class*="__text"]',
    '[class*="__photo"]',
    '[class*="__member"]',
    'li[class*="__item"]'
  ].join(',');

  /* Heeft al een eigen beweging, of verschuift zelf (transforms, een
     carrousel, een kaart). */
  var NIET = [
    '.klaasje-cinematic',
    'klaasje-scroll-cinematic',
    '.klaasje-social',
    '.klaasje-community',
    '.klaasje-card',
    'klaasje-product-card',
    '.klaasje-recent__track',
    '.leaflet-container',
    '[class*="__viewer"]',
    '.klaasje-intro',
    '.klaasje-header',
    '.drawer',
    'cart-drawer',
    '[role="dialog"]',
    '#shopify-pc__banner',
    '#shopify-pc__prefs'
  ].join(',');

  /* Foto's over de volle breedte op een navy vlak komen binnen met een
     zoom in plaats van schuiven en vervagen: schuiven liet bovenin een
     navy strook zien en vervagen gaf de foto een blauwe zweem (eigenaar).
     Zo dekt de foto het vlak de hele tijd. */
  var ZOOM = '.klaasje-banner__media';

  var html = document.documentElement;

  /* In een eigen schuifgebied (de lijst met verkooppunten op een telefoon)
     komt iets pas in beeld als je dáárin scrolt; dat laten we met rust. */
  function inSchuifgebied(el, bak) {
    for (var n = el.parentElement; n && n !== bak; n = n.parentElement) {
      var st = getComputedStyle(n);
      if (/(auto|scroll)/.test(st.overflowY + st.overflowX)) return true;
    }
    return false;
  }

  function kandidaten() {
    var bakken = [document.getElementById('MainContent')];
    document.querySelectorAll('.shopify-section-group-footer-group').forEach(function (el) {
      bakken.push(el);
    });
    var lijst = [];
    bakken.forEach(function (bak) {
      if (!bak) return;
      bak.querySelectorAll(DOEL).forEach(function (el) {
        if (el.closest(NIET)) return;
        /* binnen een ander gekozen element: dat blok komt als geheel */
        var ouder = el.parentElement && el.parentElement.closest(DOEL);
        if (ouder && bak.contains(ouder) && !ouder.closest(NIET)) return;
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        /* links of rechts buiten beeld (een schuifstrook): komt nooit in
           beeld, en zou dan onzichtbaar blijven */
        if (r.right <= 0 || r.left >= window.innerWidth) return;
        var pos = getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') return;
        if (inSchuifgebied(el, bak)) return;
        lijst.push(el);
      });
    });
    return lijst;
  }

  function binnen(el, vertraging) {
    el.classList.remove('klaasje-m');
    el.style.setProperty('--klaasje-m-delay', vertraging + 's');
    el.classList.add('klaasje-m-in');
    var klaar = function (e) {
      if (e && e.target !== el) return;
      el.removeEventListener('animationend', klaar);
      el.classList.remove('klaasje-m-in', 'klaasje-m-zoom');
      el.style.removeProperty('--klaasje-m-delay');
    };
    el.addEventListener('animationend', klaar);
    /* vangnet als animationend niet komt */
    setTimeout(klaar, 1600 + vertraging * 1000);
  }

  var io = new IntersectionObserver(
    function (entries) {
      /* wat tegelijk binnenkomt, komt na elkaar: van boven naar beneden */
      var nu = entries
        .filter(function (e) { return e.isIntersecting; })
        .map(function (e) { return e.target; })
        .sort(function (a, b) {
          return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
        });
      nu.forEach(function (el, i) {
        io.unobserve(el);
        var vertraging = Math.min(i * 0.07, 0.35);
        /* een zoomfoto die nog laadt: pas zoomen als hij er is */
        var img = el.classList.contains('klaasje-m-zoom') && el.querySelector('img');
        if (img && !img.complete) {
          var los = function () {
            img.removeEventListener('load', los);
            img.removeEventListener('error', los);
            binnen(el, 0);
          };
          img.addEventListener('load', los);
          img.addEventListener('error', los);
          return;
        }
        binnen(el, vertraging);
      });
    },
    { rootMargin: '0px 0px -6% 0px' }
  );

  function start() {
    var laadscherm = html.classList.contains('klaasje-intro-open');
    var hoog = window.innerHeight;
    var gekozen = kandidaten();

    gekozen.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var inBeeld = r.top < hoog && r.bottom > 0;
      if (inBeeld && !laadscherm) return;
      el.classList.add('klaasje-m');
      if (el.matches(ZOOM)) el.classList.add('klaasje-m-zoom');
    });

    var observeer = function () {
      gekozen.forEach(function (el) {
        if (el.classList.contains('klaasje-m')) io.observe(el);
      });
    };

    if (!laadscherm) {
      observeer();
      return;
    }
    /* Pas als het laadscherm vervaagt, anders speelt het onder het vlak af.
       Komt dat event niet (het intro stapt er eerder uit), dan bij done. */
    var gestart = false;
    var eenmaal = function () {
      if (gestart) return;
      gestart = true;
      observeer();
    };
    document.addEventListener('klaasje:intro-leaving', eenmaal);
    document.addEventListener('klaasje:intro-done', eenmaal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
